<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'default'
}
</script>

<style></style>
